import { createContext, type PropsWithChildren, useMemo, useState } from 'react';

/**
 * Simple piece of state you need to share across the App components
 * but that you don't want to put in Redux to avoid cluttering it with oneway communications
 *
 * example: show a panel that manages it's own persistent state, can be shown and hidden,
 * and whose data does not need to be exploited outside of the panel
 */
type NonReduxStateContextValue = {
  showVoiceTimestampingPanel: boolean;
  setShowVoiceTimestampingPanel: (show: boolean) => void;
};

export const nonReduxStateContext = createContext<NonReduxStateContextValue>({
  showVoiceTimestampingPanel: false,
  setShowVoiceTimestampingPanel: () => {},
});

export const NonReduxStateContextProvider = ({ children }: PropsWithChildren) => {
  const [showVoiceTimestampingPanel, setShowVoiceTimestampingPanel] = useState(false);

  const contextValue: NonReduxStateContextValue = useMemo(
    () => ({
      showVoiceTimestampingPanel,
      setShowVoiceTimestampingPanel: (show) => setShowVoiceTimestampingPanel(show), // new function to restrict typing
    }),
    [showVoiceTimestampingPanel],
  );
  return <nonReduxStateContext.Provider value={contextValue}>{children}</nonReduxStateContext.Provider>;
};
